import { useParams } from 'react-router';

export function useRouteParams<T extends Record<string, string | undefined>>(): T {
  return useParams() as T;
}
